import React, {useEffect, useRef, useState} from "react";
import {Table, Button, Row, Col, Space, PaginationProps, message} from "antd";
import {columns} from "./config";
import {pharmacyStoreService} from "api";
import {ListActionButton} from "components/common";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalContent from "./ModalContent/ModalContent";
import moment from "moment";
import Notification from "components/common/notification/notification";
import {renderSTT} from "helper/common";

const MedicineGroup = () => {
  const modalRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const [listMedicineGroup, setListMedicineGroup] = useState<any>();
  const [loading, setLoading] = useState(false);
  const nameCatalog = "nhóm thuốc";
  const dataSource = [{STT: 1, id: 1, name: 1, description: 1, modifieBy: ""}];
  useEffect(() => {
    getListMedicineGroup();
  }, []);
  columns.find(e => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteMedicineGroup(_record.id);
        }}
        editFunction={() => {
          setType("Sửa");
          setRecord(_record);
          modalRef.current?.openModal();
        }}
      ></ListActionButton>
    );
  };
  const _renderSTT = (page, limit) => {
    columns.find(e => e.dataIndex == "stt").render = (
      value,
      _record,
      index
    ) => {
      return <>{renderSTT(index, page, limit)}</>;
    };
  };
  const getListMedicineGroup = async () => {
    setLoading(true);
    try {
      const res = await pharmacyStoreService.getListMedicineGroup();
      setListMedicineGroup(res.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", `Đã xảy ra lỗi khi lấy danh sách ${nameCatalog}`);
    }
  };
  const deleteMedicineGroup = async id => {
    try {
      const res = await pharmacyStoreService.deleteMedicineGroup(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");

      await getListMedicineGroup();
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
  };

  const onChange: PaginationProps["onChange"] = (page, pageSize) => {
    // getListMedicineGroup();
    _renderSTT(page, pageSize);
  };
  useEffect(() => {
    // console.log(record);
  }, [record]);
  return (
    <Space
      direction="vertical"
      className="MedicineGroup container"
      style={{width: "100%"}}
    >
      <Row justify={"space-between"}>
        <Col>
          {" "}
          <div className="title">Danh mục {nameCatalog}</div>{" "}
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={() => {
              setType("Thêm");
              setRecord(null);
              modalRef.current?.openModal();
            }}
          >
            Thêm mới
          </Button>
        </Col>
      </Row>
      <div className="container-table">
        <Table
          loading={loading}
          bordered
          columns={columns}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            onChange: onChange,
          }}
          dataSource={listMedicineGroup}
        ></Table>

        <ModalCustom
          ref={modalRef}
          width={1000}
          title={`${type} ${nameCatalog}`}
        >
          <ModalContent
            nameCatalog={nameCatalog}
            data={record}
            getListMedicineGroup={getListMedicineGroup}
            type={type}
          ></ModalContent>
        </ModalCustom>
      </div>
    </Space>
  );
};
export default MedicineGroup;
